(function () {
    'use strict';

    angular
        .module('app')
        .controller('QueueController', QueueController);

    QueueController.$inject = ['$scope', 'QueueService', '$interval', '$timeout'];

    function QueueController($scope, QueueService, $interval, $timeout) {
        var vm = this;
        vm.jobs = [];
        vm.queued = [];
        vm.running = [];
        vm.finished = [];
        vm.stats = { queued: 0, running: 0, finished: 0, failed: 0 };
        vm.activeJob = null;
        vm.loading = false;

        vm.loadData = function () {
            vm.loading = true;

            // Cargar estadísticas
            QueueService.getStats(function (data) {
                vm.stats = data;
            });

            // Cargar listado
            QueueService.getList(function (data) {
                vm.jobs = data;
                vm.groupJobs();
                vm.loading = false;
            });
        };

        vm.groupJobs = function () {
            vm.queued = [];
            vm.running = [];
            vm.finished = [];

            angular.forEach(vm.jobs, function (job) {
                if (job.status === 'PENDING') {
                    vm.queued.push(job);
                } else if (job.status === 'RUNNING') {
                    vm.running.push(job);
                } else {
                    vm.finished.push(job);
                }
            });
        };

        vm.refresh = function () {
            vm.loadData();
        };

        vm.viewLog = function (job) {
            vm.activeJob = job;
            // Usamos $timeout para asegurar que el DOM del modal esté listo si fuera necesario, 
            // aunque aquí simplemente abrimos el modal de Bootstrap
            var modal = new bootstrap.Modal(document.getElementById('logModal'));
            modal.show();
        };

        vm.retry = function (job) {
            vm.loading = true;
            QueueService.retry(job.job_id, function (data) {
                vm.loadData();
            });
        };

        vm.cancelJob = function (job) {
            showConfirmModal(
                'Cancelar Trabajo',
                '¿Estás seguro de que quieres cancelar este trabajo?',
                'El proceso será terminado inmediatamente.',
                function () {
                    vm.loading = true;
                    QueueService.cancelJob(job.job_id).then(function (response) {
                        if (response.success) {
                            vm.loadData();
                            showToast('Trabajo cancelado', 'El trabajo ha sido cancelado exitosamente.', 'success');
                        } else {
                            showToast('Error', response.message || 'No se pudo cancelar el trabajo', 'danger');
                            vm.loading = false;
                        }
                    });
                }
            );
        };

        function showConfirmModal(title, message, detail, onConfirm) {
            var modalId = 'confirmModal-' + Date.now();
            var modalHtml =
                '<div class="modal fade" id="' + modalId + '" tabindex="-1" aria-hidden="true">' +
                '<div class="modal-dialog modal-dialog-centered">' +
                '<div class="modal-content border-0 shadow-lg">' +
                '<div class="modal-header bg-warning bg-opacity-10 border-0">' +
                '<h5 class="modal-title d-flex align-items-center">' +
                '<span class="material-symbols-outlined text-warning me-2">warning</span>' +
                title +
                '</h5>' +
                '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>' +
                '</div>' +
                '<div class="modal-body">' +
                '<p class="mb-2"><strong>' + message + '</strong></p>' +
                '<p class="text-muted small mb-0">' + detail + '</p>' +
                '</div>' +
                '<div class="modal-footer border-0">' +
                '<button type="button" class="btn btn-secondary rounded-pill px-4" data-bs-dismiss="modal">Cancelar</button>' +
                '<button type="button" class="btn btn-warning rounded-pill px-4" id="confirmBtn-' + modalId + '">' +
                '<span class="material-symbols-outlined" style="font-size: 18px; vertical-align: middle;">cancel</span> ' +
                'Sí, cancelar trabajo' +
                '</button>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</div>';

            document.body.insertAdjacentHTML('beforeend', modalHtml);
            var modalElement = document.getElementById(modalId);
            var modal = new bootstrap.Modal(modalElement);

            document.getElementById('confirmBtn-' + modalId).addEventListener('click', function () {
                modal.hide();
                if (onConfirm) onConfirm();
            });

            modalElement.addEventListener('hidden.bs.modal', function () {
                modalElement.remove();
            });

            modal.show();
        }

        function showToast(title, message, type) {
            type = type || 'info';
            var toastId = 'toast-' + Date.now();
            var iconMap = {
                'success': 'check_circle',
                'danger': 'error',
                'warning': 'warning',
                'info': 'info'
            };
            var bgMap = {
                'success': 'bg-success',
                'danger': 'bg-danger',
                'warning': 'bg-warning',
                'info': 'bg-info'
            };

            var toastHtml = '<div id="' + toastId + '" class="toast align-items-center text-white border-0 ' + bgMap[type] + '" role="alert" aria-live="assertive" aria-atomic="true">' +
                '<div class="d-flex">' +
                '<div class="toast-body d-flex align-items-center">' +
                '<span class="material-symbols-outlined me-2">' + iconMap[type] + '</span>' +
                '<div>' +
                '<strong>' + title + '</strong><br>' +
                '<small>' + message + '</small>' +
                '</div>' +
                '</div>' +
                '<button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>' +
                '</div>' +
                '</div>';

            var container = document.getElementById('toast-container');
            if (!container) {
                container = document.createElement('div');
                container.id = 'toast-container';
                container.className = 'toast-container position-fixed top-0 end-0 p-3';
                container.style.zIndex = '9999';
                document.body.appendChild(container);
            }

            container.insertAdjacentHTML('beforeend', toastHtml);
            var toastElement = document.getElementById(toastId);
            var toast = new bootstrap.Toast(toastElement, { delay: 4000 });
            toast.show();

            toastElement.addEventListener('hidden.bs.toast', function () {
                toastElement.remove();
            });
        }

        vm.getElapsed = function (timestamp) {
            if (!timestamp) return '...';
            var seconds = Math.floor((Date.now() / 1000) - timestamp);
            if (seconds < 60) return seconds + 's';
            return Math.floor(seconds / 60) + 'm';
        };

        vm.getDuration = function (started_at, finished_at) {
            if (!started_at) return '0s';
            var end = finished_at ? finished_at : (Date.now() / 1000);
            var seconds = Math.floor(end - started_at);
            if (seconds < 0) seconds = 0;
            if (seconds < 60) return seconds + 's';
            return Math.floor(seconds / 60) + 'm ' + (seconds % 60) + 's';
        };

        // Auto-refresh cada 3 segundos para el modo Kanban
        var refreshInterval = $interval(function () {
            vm.loadData();
        }, 3000);

        $scope.$on('$destroy', function () {
            if (angular.isDefined(refreshInterval)) {
                $interval.cancel(refreshInterval);
            }
        });

        // Inicializar
        vm.loadData();
    }
})();
